import { businessApi } from "../businessApi";
import { transformUpdateWaitingTimes, transformWaitingTimes } from "./helpers";
import { GetWaitingTimesResponse, UpdateWaitingTimesParams, UpdateWaitingTimesResponse } from "./types";

export const waitingTimesApi = businessApi.enhanceEndpoints({ addTagTypes: ["WaitingTimes"] }).injectEndpoints({
  endpoints: (builder) => ({
    getWaitingTimes: builder.query<GetWaitingTimesResponse, void>({
      query: () => `/wait-times`,
      transformResponse: transformWaitingTimes,
      providesTags: ["WaitingTimes"],
    }),
    updateWaitingTimes: builder.mutation<UpdateWaitingTimesResponse, UpdateWaitingTimesParams>({
      query: (body) => ({
        url: `/wait-times`,
        method: "PUT",
        body: body,
      }),
      transformResponse: transformUpdateWaitingTimes,
      invalidatesTags: ["WaitingTimes"],
    }),
  }),
});

export const { useGetWaitingTimesQuery, useUpdateWaitingTimesMutation } = waitingTimesApi;
